module.exports = __webpack_public_path__ + "media/images/emoticons/happy02-c98a88167241ea8c4668d2eca758d4d2.gif";